export enum WebChatBotAccountMenuTab {
  generalInfo = "generalInfo",

  generalSetup = "generalSetup",
  launcherStyle = "launcherStyle",
  cta = "cta",
  suggestions = "suggestions",

  install = "install",
}
